import React, { useState } from 'react';
import Menu from '../../components/Menu';
import api from '../../services/api';
import { Popover } from 'react-tiny-popover'


function Cadastro(props){    
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [usuario, setUsuario] = useState('');
    const [cpf, setCpf] = useState('');
    const [nome, setNome] = useState('');
    const [senha, setSenha] = useState('');
    const [plano, setPlano] = useState('');
    const [repitaSenha, setRepitaSenha] = useState('');
    const [msg, setMsg] = useState('');
    const [btnLogarSe, setBntLogueSe] = useState(false);
    const [email, setEmail] = useState('');
    const [telefone, setTelefone] = useState('');

    const handleVoltar = () => {
        window.location.href = '../../../';
        return;
    };
    const handleCadastrar = async() => {
        setMsg('');
        var res = await api.post('/Cadastre-se', {cpf, nome, email, telefone, usuario, plano, senha, repitaSenha});
        console.log(res.data);
        if(typeof res.data.msg != 'undefined') {
            if(typeof res.data.token != 'undefined') {
                setMsg(res.data.msg ?? 'Aguarde, redirecionando...');
                window.localStorage.setItem('token', res.data.token);
                setTimeout(() => {
                    window.location = 'Painel'; 
                    return;  
                }, 500);
          
            } else if(res.data.msg.indexOf('logue-se para continua') != -1) {
                setBntLogueSe(true);
                setMsg(res.data.msg);
            } else{
                setBntLogueSe(false);
                setMsg(res.data.msg);
            }
        }
    };

    const Voltar = (e) => {
        e.preventDefault(0);
        window.location = './Painel';
        return;
    }

    return (<div class="main-content" style={{marginLeft: '0'}}>
    <div id="page-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-md-offset-4" style={{marginTop: '100px'}}>
                    <img src={'../../public/assets/logoupbusca.png'} alt="Up Busca" class="center-block img-responsive" id="logo" style={{marginTop: '-10%'}}/>
                </div>
            </div>
        </div>
    <div>

      <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <ul class="nav nav-tabs" role="tablist" style={{marginTop: '0px'}}>
                <li role="presentation" class="active">
                    <a href="#home" aria-controls="home" role="tab" data-toggle="tab" class="tab-result">Cadastre-se</a>
                </li>
            </ul>

            <div class="tab-content">
                <div role="tabpanel" class="tab-pane active" id="home">
                    <div class="table-responsive" style={{marginTop: '12px'}}>
                    <div class="row">
			
                        <div>
                        <div class="form-group col-md-12">
                                <span>CPF:</span>
                                <input type="text" class="form-control" id="cpf" name="cpf" value={cpf} onChange={(e)=> setCpf(e.target.value)} placeholder='000.000.000-00'/>
                            </div>

                            <div class="form-group col-md-12">
                                <span>Nome completo:</span>
                                <input type="text" class="form-control" id="nome" name="nome" value={nome} onChange={(e)=> setNome(e.target.value)} placeholder='Digite seu nome completo'/>
                            </div>
                            <div class="form-group col-md-12">
                                <span>E-mail:</span>
                                <input type="text" class="form-control" id="email" name="email" value={email} onChange={(e)=> setEmail(e.target.value)} placeholder='fulano@email.com'/>
                            </div>
                            <div class="form-group col-md-12">
                                <span>Telefone Celular:</span>
                                <input type="text" class="form-control" id="celular" name="celular" value={telefone} onChange={(e)=> setTelefone(e.target.value)} placeholder='DDD + NUMERO'/>
                            </div>

                            <div class="form-group col-md-12">
                                <span>Usuario:</span>
                                <input type="text" class="form-control" id="usuario" name="usuario" value={usuario} onChange={(e)=> setUsuario(e.target.value)} placeholder='Seu usuario'/>
                            </div>

                            <div class="form-group col-md-12">
                                <span>Senha:</span>
                                <input type="password" class="form-control" id="senha" name="senha" placeholder="Digite sua senha" value={senha} onChange={(e)=> setSenha(e.target.value)}/>
                            </div>
                            <div class="form-group col-md-12">
                                <span>Repita a Senha:</span>
                                <input type="password" class="form-control" id="senha" name="senha" placeholder="Repita sua senha" value={repitaSenha} onChange={(e)=> setRepitaSenha(e.target.value)}/>
                            </div>
                            <div class="form-group col-md-12">
                                <br/>
                            
    <>
    <div>

<input type="radio" class="" id="plano" name="plano" value={2} onChange={(e)=> setPlano(e.target.value)}/> Plano 30 dias por R$ 34,00 ( Limite de 300 pesquisas )
</div>

<div style={{marginTop: '10px'}}>

<input type="radio" checked class="" id="plano" name="plano" value={1} onChange={(e)=> setPlano(e.target.value)}/> Plano 30 dias por R$ 69,99 ( Limite de 1400 pesquisas )
</div>
</>



                            </div>
                            <div className='form-groud col-md-12'>
                                <p style={{fontWeight: 'bold', textAlign: 'center'}}>
                                    {msg ?? ''}
                                    {btnLogarSe == true ? <a href="../../Logue-se">Clique aqui!</a> : ''}
                                </p>
                            </div>
                            <div className='form-groud col-md-12'>
                            <br/>
                                <center>
                                    <button id="btAtualizarSenha" onClick={handleCadastrar} type="button" class="btn btn-primary">Cadastrar</button>
                                    <button id="btAtualizarSenha" onClick={handleVoltar} style={{marginLeft: '10px'}} type="button" class="btn btn-dark">Voltar</button>
                                    
                                </center>
                            </div>

                        </div>
                        <br/>
                    
                    </div>
                    <br/>
                    </div>
                </div>
            </div>
        </div>
    </div>

  
</div>

</div></div>);
}

export default Cadastro;
